if (!customElements.get('tabbed-image-showcase')) {
  class TabbedImageShowcase extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activateTab(tab));
        tab.addEventListener('keydown', (event) => this.handleKeydown(event));
      });

      if (window.Shopify?.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          const tab = this.querySelector(`[role="tab"][data-block-id="${event.detail.blockId}"]`);
          if (tab) this.activateTab(tab);
        });
      }
    }

    activateTab(activeTab, moveFocus = false) {
      const activePanelId = activeTab.dataset.tabTarget;

      this.tabs.forEach((tab) => {
        const isActive = tab === activeTab;
        tab.setAttribute('aria-selected', isActive);
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.panels.forEach((panel) => {
        const isActive = panel.id === activePanelId;
        panel.hidden = !isActive;
        panel.classList.remove('is-active');

        if (isActive) {
          void panel.offsetWidth;
          panel.classList.add('is-active');
        }
      });

      if (moveFocus) activeTab.focus();
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      activeTab.scrollIntoView({ behavior, block: 'nearest', inline: 'nearest' });
    }

    handleKeydown(event) {
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;

      if (nextIndex === currentIndex) return;

      event.preventDefault();
      this.activateTab(this.tabs[nextIndex], true);
    }
  }

  customElements.define('tabbed-image-showcase', TabbedImageShowcase);
}
